import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      if (u.role === "admin") navigate("/admin");
      else navigate("/feed");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const onGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/feed";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-3.5rem)] grid md:grid-cols-2">
      <div className="hidden md:block bg-[#1E3F33] relative vc-grain">
        <img alt="" src="https://images.pexels.com/photos/26728094/pexels-photo-26728094.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700" className="absolute inset-0 w-full h-full object-cover mix-blend-luminosity opacity-30" />
        <div className="relative h-full flex flex-col justify-end p-12 text-white">
          <span className="text-xs uppercase tracking-[0.2em] text-[#D96C5B] font-semibold">Welcome back</span>
          <h2 className="text-4xl font-bold mt-3 leading-tight">Sign in to your<br />visual resume.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h1 className="text-3xl font-bold tracking-tight">Sign in</h1>
          <p className="text-sm text-[#68706B] mt-2">No account? <Link to="/register" className="text-[#1E3F33] font-semibold underline">Create one</Link></p>

          <div className="mt-8 space-y-3">
            <Input data-testid="login-email" placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-none h-11" required />
            <Input data-testid="login-password" placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-none h-11" required />
            <Button data-testid="login-submit" disabled={loading} className="w-full h-11 rounded-none bg-[#1E3F33] hover:bg-[#152C24]" type="submit">
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </div>
          <div className="my-6 flex items-center gap-3 text-xs text-[#68706B] uppercase tracking-[0.2em]">
            <span className="flex-1 h-px bg-[#E2E4E2]" /> or <span className="flex-1 h-px bg-[#E2E4E2]" />
          </div>
          <Button type="button" onClick={onGoogle} variant="outline" className="w-full h-11 rounded-none border-[#1E3F33]" data-testid="login-google">
            Continue with Google
          </Button>
        </form>
      </div>
    </div>
  );
}
